import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Select } from "../components/ui/Select";
import type { Option } from "../components/ui/Select";
import uzFlag from "../assets/images/flags/uz.png";
import ruFlag from "../assets/images/flags/ru.png";

const LanguageSelector: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { i18n } = useTranslation();
  const currentLang = i18n.language;

  const handleChange = (lang: string) => {
    const pathParts = location.pathname.split("/");
    pathParts[1] = lang; // tilni URL'da yangilash
    const newPath = pathParts.join("/") || `/${lang}`;
    navigate(newPath); // navigate qilsak, App ichidagi useEffect i18n.changeLanguage ni o’zi qiladi
    window.location.reload();
  };

  const options: Option[] = [
    {
      value: "uz",
      label: (
        <div className="flex items-center gap-2">
          <img src={uzFlag} alt="uzbek_flag" loading="eager"  className="w-5 h-5 rounded-full object-cover" />
          <span>O‘zbekcha</span>
        </div>
      ),
    },
    {
      value: "ru",
      label: (
        <div className="flex items-center gap-2">
          <img src={ruFlag} alt="russian_flag"  loading="eager" className="w-5 h-5 rounded-full object-cover" />
          <span>Русский</span>
        </div>
      ),
    },
  ];

  const selectedOption = options.find((opt) => opt.value === currentLang) ?? options[0];
  const filteredOptions = options.filter((opt) => opt.value !== selectedOption.value);

  return (
    <div className="w-full">
      <Select
        value={selectedOption.value}
        onChange={handleChange}
        options={filteredOptions}
        selected={selectedOption}
      />
    </div>
  );
};

export default LanguageSelector;
